import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { loadExternalScript } from '../../shared/utils/load-external-script';

@Component({
  selector: 'cc-dynamic-zaps-initiation',
  templateUrl: './dynamic-zaps-initiation.component.html',
  styleUrls: ['./dynamic-zaps-initiation.component.scss']
})
export class DynamicZapsInitiationComponent implements OnInit, AfterViewInit {
  @ViewChild('zapierScript') zapierScript: ElementRef;

  constructor() {}

  ngOnInit() {}

  ngAfterViewInit() {
    loadExternalScript(
      this.zapierScript,
      'https://zapier.com/apps/embed/widget.js?services=channels&limit=10&html_id=zapier-list'
    );
  }
}
